export class Page {
  screenName: string
  timeline: gsap.core.Timeline

  constructor(screenName: string, animationTimeline: gsap.core.Timeline) {
    this.screenName = screenName
    this.timeline = animationTimeline
  }

  transitionIn() {
    this.timeline.progress(0)
    return new Promise((resolve) => {
      if (this.timeline.duration() == 0) return resolve()
      this.timeline.restart().eventCallback('onComplete', function () {
        resolve()
      })
    })
  }

  transitionOut() {
    this.timeline.progress(1)
    return new Promise((resolve) => {
      if (this.timeline.duration() == 0) return resolve()
      this.timeline.reverse().eventCallback('onUpdate', function () {
        if (this.totalProgress() <= 0.15) resolve()
      })
    })
  }
}

export default Page
